import { OrderService } from './../../service/orderService/order.service';
import { LoginService } from './../../service/login.service';
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatTableModule,MatTableDataSource} from '@angular/material/table' 
import {MatPaginator} from '@angular/material/paginator';import {PageEvent} from '@angular/material/paginator';
import { MatFormFieldModule,MatFormField } from '@angular/material/form-field';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute, RouterModule, Router } from '@angular/router';
import { SelectionModel } from '@angular/cdk/collections';

@Component({
  selector: 'app-order-manager',
  templateUrl: './order-manager.component.html',
  styleUrls: ['./order-manager.component.scss']
})
export class OrderManagerComponent  {
  member:any=[];
  displayedColumns: string[] = ['OrderID','order_date','Customer_Name','customer_mobile','dishesNo','TotalPrice','ORDER_STATUS'];
  displayedColumns1: string[] = ['OrderID','order_date','Customer_Name','customer_mobile','dishesNo','TotalPrice'];

  memberss=new MatTableDataSource(this.member);
  @ViewChild(MatPaginator ,{static:true}) paginator:MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  constructor( private route:Router,private apiService:OrderService) { }
  
  ngAfterViewInit(): void {
    this.memberss.paginator=this.paginator;
    this.memberss.sort=this.sort;
    this.getMember()
  }
  applyFilter(filterValue:string)
  {
    this.memberss.filter=filterValue.trim().toLowerCase();
  }
  logData(row)
  {
    console.log(row.id);
    
  }
  changeOrderStatus(value,data)
  {
console.log(value,data)
this.apiService.EditOrderDetail(value,data).then((res)=>
{
  console.log(res)
})
  }
  edit(id)
  {
    console.log(id);
    this.route.navigate(['/dashboard/editmember',id])
  }
  getMember()
  {  
    this.apiService.getOrder().then((data)=>{
     this.member= JSON.parse(JSON.stringify(data));
     this.memberss.data=this.member;
    console.log(this.memberss.data)
    })
    
  }
  take(a)
  {
    console.log(a)
    this.route.navigate(['/dashboard/orderDetail',a])
  }
  // deleteTicket(){
  //   const id=localStorage.getItem('LoginId')
  //   this.member.forEach(item => {
  //     let index = this.memberss.data.findIndex(d => d === item);
  //     console.log(this.memberss.data.findIndex(d => d === item));
  //     this.memberss.data.splice(index,+id)
  //     this.memberss = new MatTableDataSource<Element>(this.member);
  //   });
  //   this.member = new SelectionModel<Element>(true, []);
  //   console.log(this.memberss)
  // }
  addMember()
  {
    this.route.navigateByUrl("dashboard/add");
  }
  deleteMember(id)
  {
    this.apiService.deleteOrderDetail(id).then(()=>{
      console.log(`member is deleted`)
      location.reload();
    }
      );
    
  }

}
